export const formatDisplayId = (id: number | string | null | undefined): string => {
    if (id === null || id === undefined) {
        return "";
    }

    const displayId = String(id).trim();

    if (!/^\d+$/.test(displayId)) {
        return displayId;
    }

    return displayId.replace(/^0+(?=\d)/, "");
};
